import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import { GlgSimpleCheckbox, GlgTooltip } from 'Shared/components'
import useContainerSize from 'Shared/hooks/useContainerSize'

import LeaguesTypeIcon from '../common/LeaguesTypeIcon'
import LeagueRoundsTooltipChip from './LeagueRoundsTooltipChip'

const LeaguesBrowserItem = ({item, onCheckChanged, isSelected}) => {
  const containerRef = useRef(null)
  const labelRef = useRef(null)

  /*
  Observe the container (not the label) so the ref target is stable.
  The label moves in/out of GlgTooltip when isOverflowing toggles, causing React to
  unmount/remount it. Observing the remounted node is impossible because useContainerSize
  captures the DOM node at effect time. The container div never remounts, so its observer
  always fires on resize and triggers the re-render needed to recompute isOverflowing.
  */
  useContainerSize(containerRef)

  const isOverflowing = labelRef.current
    ? labelRef.current.scrollWidth > labelRef.current.clientWidth
    : false

  const nameLabel = (
    <label
      ref={labelRef}
      className={isSelected ? 'cls-lb-item-label-selected' : 'cls-lb-item-label'}
    >
      {item.name}
    </label>
  )

  return (
    <div
      ref={containerRef}
      key={item.id}
      className={`cls-lb-item-container${isOverflowing ? ' cls-lb-item-container--overflow' : ''}`}
      onClick={() => onCheckChanged(item.id)}
      >
      <GlgSimpleCheckbox
        checked={isSelected}
        className='cls-lb-item-checkbox'
      />
      {isOverflowing
        ? <GlgTooltip tooltip={item.name}>{nameLabel}</GlgTooltip>
        : nameLabel
      }
      <LeagueRoundsTooltipChip league={item}/>
      <LeaguesTypeIcon leagueType={item.product} compact/>
    </div>
  )
}

LeaguesBrowserItem.propTypes = {
  item: PropTypes.object.isRequired,
  onCheckChanged: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
}

export default LeaguesBrowserItem
